<template>
    <x-page title="Edit Kategori Group">
        <template #header-actions>
            <x-back-button :disabled="isLoading" />
        </template>
        <group-category-form id="group-category-form"
            v-if="Boolean(resource)"
            @submit="handleSubmit"
            :disabled="isLoading"
            :errors="errors"
            :initialFields="resource" />
        <template #footer>
            <x-submit-button form="group-category-form"
                :is-loading="isLoading"
                :disabled="isLoading" />
        </template>
    </x-page>
</template>

<script>
import XBackButton from '../../components/XBackButton.vue'
import XPage from '../../components/XPage.vue'
import XSubmitButton from '../../components/XSubmitButton.vue'
import { handleGeneralXhrError, handleValidationXhrError } from '../../helpers'
import GroupCategoryForm from './GroupCategoryForm.vue'

export default {
    components: {
        XPage,
        XBackButton,
        XSubmitButton,
        GroupCategoryForm,
    },
    created() {
        this.fetchResource()
    },
    data() {
        return {
            errors: null,
            isLoading: false,
            resource: null,
        }
    },
    methods: {
        fetchResource() {
            this.isLoading = true
            const request = axios.get(`/api/group-categories/${this.$route.params.id}`, {
                params: {
                    append: ['enter_trigger', 'exit_trigger'],
                }
            })
            .then(response => {
                this.resource = response.data.data;
                if (this.resource.enter_trigger) {
                    this.resource.enter_trigger.active = true;
                }
                if (this.resource.exit_trigger) {
                    this.resource.exit_trigger.active = true;
                }
            })
            return handleGeneralXhrError(request).finally(() => {
                this.isLoading = false
            })
        },
        handleSubmit(fields) {
            this.isLoading = true
            const request = axios.put(`/api/group-categories/${this.$route.params.id}`, fields)
                .then(() => {
                    this.$notify({
                        type: 'success',
                        title: `Berhasil`,
                        text: `${fields.label} updated!`,
                    })
                    this.$router.back()
                })
            return handleValidationXhrError(request, errors => {
                this.errors = errors
                this.isLoading = false
            })
        },
    },
}
</script>